import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from './role.model';
import { URL_BASE } from '../../core/constants';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '../../shared/http-utils';
import { map } from 'rxjs/operators';
import { Permission } from './permission.model';

@Injectable()
export class RoleService {

  private ROLES_URI = 'api/roles';

  constructor(private http: HttpClient) {
  }

  public getAll(): Observable<Array<Role>> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.ROLES_URI}`;

    return this.http.get(url, { headers })
      .pipe(
        map((roles: any[]) => roles.map(r => Role.fromDto(r)))
      );
  }

  public getById(id: string): Observable<Role> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.ROLES_URI}/${id}`;

    return this.http.get(url, { headers })
      .pipe(
        map(r => Role.fromDto(r))
      );
  }

  public create(role: Role): Observable<Role> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.ROLES_URI}`;

    return this.http.post(url, role, { headers })
      .pipe(
        map(r => Role.fromDto(r))
      );
  }

  public update(role: Role): Observable<Role> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.ROLES_URI}/${role.id}`;

    return this.http.put(url, role, { headers })
      .pipe(
        map(r => Role.fromDto(r))
      );
  }

  public remove(id: string): Observable<boolean> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.ROLES_URI}/${id}`;

    return this.http.delete<boolean>(url, { headers });
  }

  public addPermissionsToRole(role: Role, permissions: Permission[]): Observable<void> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.ROLES_URI}/${role.id}/permissions`;
    const payload = {
      permissions,
    };

    return this.http.post<void>(url, payload, { headers });
  }

  public removePermissionsFromRole(role: Role, permissions: Permission[]): Observable<void> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.ROLES_URI}/${role.id}/permissions`;
    const payload = {
      permissions,
    };

    return this.http.request<void>('DELETE', url, { headers, body: payload, });
  }
}
